// extracted by mini-css-extract-plugin
module.exports = {"headingBannerContainer":"headingBanner-module--headingBannerContainer--3ZxUN","content":"headingBanner-module--content--S_8mo"};